import React from 'react';

interface NewsArticle {
  id: string;
  title: string;
  summary: string;
  link: string;
  date: string;
}

const dummyNews: NewsArticle[] = [
  {
    id: '1',
    title: 'New Income Tax Rules for FY 2024-25 Announced',
    summary: 'The Ministry of Finance has released new guidelines for income tax, impacting salaried individuals and businesses.',
    link: '#',
    date: 'July 25, 2025',
  },
  {
    id: '2',
    title: 'RBI Revises Repo Rate: Impact on Loans and EMIs',
    summary: 'The Reserve Bank of India has announced changes to the repo rate, which will affect interest rates on home loans and other EMIs.',
    link: '#',
    date: 'July 20, 2025',
  },
  {
    id: '3',
    title: 'GST Council Meeting Highlights: Key Changes for Businesses',
    summary: 'Important decisions from the recent GST Council meeting, including changes to tax rates and compliance procedures.',
    link: '#',
    date: 'July 15, 2025',
  },
];

const NewsFeed: React.FC = () => {
  return (
    <div className="news-feed-container">
      <h2>Latest Financial, Legal & Tax Updates</h2>
      {dummyNews.map((article) => (
        <div key={article.id} className="news-article">
          <h3><a href={article.link} target="_blank" rel="noopener noreferrer">{article.title}</a></h3>
          <p className="news-date">{article.date}</p>
          <p>{article.summary}</p>
        </div>
      ))}
      <p>More news coming soon! Stay tuned for real-time updates.</p>
    </div>
  );
};

export default NewsFeed;
